import Vue from 'vue';
import VueAuthMain from '@telexpress/vue-auth-main';

Vue.use(VueAuthMain);
